import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-84" data-mp="129h6c3bjvskt">
      <div className="h-1 w-full bg-primary" aria-hidden="true" data-id="element-85" data-mp="127eeddqu7pdg" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-86" data-mp="xbpc32nfnudg">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-border bg-surface px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-foreground sm:text-sm" data-id="element-87" data-mp="sa9rfbp63pvl">
          <FlameIcon className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-88" data-mp="3j7zg1kyg9whq" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-89" data-mp="3o73na61tdk5f">
          <img src={productImage} alt={productImageAlt} className="mockup-glow mx-auto w-full" data-id="element-90" data-mp="30hrev8eb9g46" />
        </motion.div>

        <div className="mt-9" data-id="element-91" data-mp="359j85qoupzy0">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-92" data-mp="35audhuxy3fr8">
            Get your professional edition now
          </Button>
        </div>
      </div>
    </section>;
}